<template>
 <div>
    <div>
      <input type="email" v-model="query" v-on:keyup="autoemail" class="form-control" 
        @focus="modal = true" value="<slot></slot>" size="100">
    </div>
  <div class="panel-footer" v-if="results.length > 0 && modal">
   <ul class="list-group">
    <li class="list-group-item" @click="setState(result.new_value)" v-for="result in results">
     {{ result.new_value }}
    </li>
   </ul>
  </div>
  <button type="button" class="form-control" v-on:click="addEmail">Ajouter</button>
  <div style="padding-top: 5px; padding-left: 5px;"><b>Liste d'envoi :</b></div>  
  <ul class="list-group">
    <li class="list-group-item" @click="removeMail(email)" v-for="email in emails">
        {{ email }}
    </li>
  </ul>
  <input type="hidden" name="emails" v-model="emails">
 </div>
</template>
<script>
 export default{
  data(){
   return {
    query: "",
    modal: false,
    results: [],
    emails: [],
    reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
   }
  },
  methods: {

   autoemail(){
    this.results = [];
    if(this.query.length > 2){
     axios.get('/api/searchemail',{params: {query: this.query}}).then(response => {
      this.results = response.data;
     });
    }
   },

   setState(state){
    this.query = state;
    this.modal = false;
   },

   addEmail() {
      if ( this.reg.test(this.query) ) {
        this.emails.push(this.query);
        this.query = "";        
      }
   },

   isEmailValid() {
    return (this.query == "")? "" : (this.reg.test(this.query)) ? 'has-success' : 'is-inval';
   },

   removeMail(email) {
    var index = this.emails.indexOf(email);
    this.emails.splice(index,1);
   }
  }
 }
</script>
